import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import styled from '@xstyled/styled-components';
import { Space } from 'antd';
import { styleVariables, AudioPlayerV2, MathEnabledTextComponent } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
var MainLayout = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  scroll-margin-top: 24px;\n  width: 100%;\n  padding: 32px 24px;\n  border-radius: 12px;\n  box-shadow: 0px 3px 6px ", ";\n  background: ", ";\n  overflow: hidden;\n"])), styleVariables.colors.transparentGray6, styleVariables.colors.gray1);
var ContentWrapper = styled(Space)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  &.last-content {\n    margin-bottom: 0;\n  }\n"])));
var QuestionTitle = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-style: normal;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n"])), styleVariables.colors.gray13);
var QuestionHeaderContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var StyledLeftCol = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-end;\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var QuestionContent = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([""])));
var QuestionContentTitle = styled(MathEnabledTextComponent)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n\n  color: ", ";\n  img {\n    max-width: 100%;\n  }\n\n  p {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray13);
var QuestionHeaderScore = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin-left: 8px;\n  color: ", ";\n"])), styleVariables.colors.gray10);
export var SubmissionBaseQuestion = function SubmissionBaseQuestion(props) {
  var _audioFileRule$isAllo, _audioFileRule$allowi;

  var question = props.question,
      label = props.label,
      children = props.children,
      hideScore = props.hideScore,
      audioPlayerLabels = props.audioPlayerLabels,
      _props$readonly = props.readonly,
      readonly = _props$readonly === void 0 ? false : _props$readonly;
  var jsonAudioFile = question === null || question === void 0 ? void 0 : question.audioFile;
  var audioFileRule = jsonAudioFile === null || jsonAudioFile === void 0 ? void 0 : jsonAudioFile.rule;
  var questionId = question === null || question === void 0 ? void 0 : question.id.toString();
  return /*#__PURE__*/_jsxs(MainLayout, {
    id: question.id.toString(),
    direction: "vertical",
    size: "middle",
    children: [/*#__PURE__*/_jsx(QuestionHeaderContainer, {
      className: "question-content",
      children: /*#__PURE__*/_jsxs(StyledLeftCol, {
        children: [/*#__PURE__*/_jsxs(QuestionTitle, {
          children: [label.questionNumber, " ", question.titleIndex]
        }), !hideScore && /*#__PURE__*/_jsxs(QuestionHeaderScore, {
          children: [question.score, " ", label.score]
        })]
      })
    }), /*#__PURE__*/_jsxs(ContentWrapper, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsx(QuestionContent, {
        children: /*#__PURE__*/_jsx(QuestionContentTitle, {
          value: question.description
        })
      }), !readonly && jsonAudioFile && /*#__PURE__*/_jsx(AudioPlayerV2, {
        source: jsonAudioFile.url,
        audioId: "question-".concat(questionId),
        audioPlayerConfig: {
          isAllowedToReplay: (_audioFileRule$isAllo = audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.isAllowedToReplay) !== null && _audioFileRule$isAllo !== void 0 ? _audioFileRule$isAllo : false,
          isAllowedToPause: (_audioFileRule$allowi = audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.allowingToPauseAndStop) !== null && _audioFileRule$allowi !== void 0 ? _audioFileRule$allowi : false,
          numberOfReplays: +(audioFileRule === null || audioFileRule === void 0 ? void 0 : audioFileRule.numberOfReplays.value) || -1
        },
        labels: audioPlayerLabels
      }), /*#__PURE__*/_jsx(QuestionContent, {
        children: children
      })]
    })]
  });
};